export default IconNavigationWest => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-navigation-west" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M9 3l1 6l2 -3.75l2 3.75l1 -6" />
  <path d="M16 21l-4 -8l-4 8l4 -2z" />
</svg>`;